(function () {
    'use strict';

    angular.module('swif.ui')
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/', {
            template: '',
            controller: MainController
        });
        $routeProvider.otherwise({redirectTo: '/'});
    }]);

    function MainController ($location, userService) {
        'ngInject';
        console.log('init MainController');
        let landingPage = userService.getLandingPage();
        console.log('redirect to '+landingPage);
        $location.path(landingPage);
    }

})();
